import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_check",
  "use": "icon-control_check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_check\"><g stroke=\"currentColor\" fill=\"transparent\"><rect x=\".5\" y=\".5\" width=\"11\" height=\"11\" rx=\"2\" transform=\"translate(2 2)\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 6l-3.774 4L5 7.64\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol